import dynamic from 'next/dynamic';
import { BlockProps } from '../BlockProps';
import { ITestimonialsBlockData } from './ITestimonialsBlockData';

export const DynamicTestimonialsBlock = dynamic<
    BlockProps<ITestimonialsBlockData>
>(() => import('./TestimonialsBlock').then(md => md.TestimonialsBlock));
